import indexOfProperty from './indexOfProperty'

/**
 * Созадние пользователя и добавление к нему методов для проверки прав доступа
 * @param userObj
 * @return {*}
 */
const createUserPolicies = function (userObj) {
  let user = Object.assign({}, userObj)
  let variantsObj = ['his', 'techcenters', 'companies', 'company', 'all']
  /**
   * Проверка наличия роли у пользователя
   * @param roleName
   * @return {boolean}
   */
  user.hasRole = (roleName) => {
    return indexOfProperty(user.roles, 'name', roleName) !== -1
  }
  /**
   * Проверка наличия разрешения у пользователя
   * @param permissionName
   * @return {boolean}
   */
  user.hasPermission = (permissionName) => {
    let permissionObj = permissionName.split('.')
    if (permissionObj[permissionObj.length - 1] === '*') {
      return variantsObj.some(function (item) {
        return indexOfProperty(user.permissions, 'name', permissionName.replace(/\*/, item))
      })
    } else {
      return indexOfProperty(user.permissions, 'name', permissionName) !== -1
    }
  }
  return user
}

export default createUserPolicies



// WEBPACK FOOTER //
// ./src/helpers/createUserPolicies.js